import React from 'react'
import styled from 'styled-components'
import { ReactComponent as FileIcon } from "../../Assets/icons/fileIcon.svg"
import { ArrowDownToLine } from "lucide-react"

const FileMessageComponent = ({ file, received, onDownload }) => {

    
    const returnMb = (size) => {
        if (!size) return;
        let mb = (size / 1000000);
        let kb = (size / 1000);
        if (mb.toFixed(2) <= 1.00) return `${kb.toFixed(2)} Kb`;
        return `${mb.toFixed(2)} Mb`;
    }

    return (
        <Container onClick={() => window.open(file.url)} received={received}>
            <IconWrapper>
                <FileIcon />
            </IconWrapper>

            <InfoWrapper received={received}>
                <h1>{file.name}</h1>
                <p>{returnMb(file.size)}</p>
            </InfoWrapper>
            
            {/* The Download Button */}
            {onDownload && (
                <DownloadButton
                    received={received}
                    onClick={(e) => {
                        e.stopPropagation();
                        onDownload();
                    }}
                    title="Download"
                >
                   <ArrowDownToLine size={16} />
                </DownloadButton>
            )}
        </Container>
    )
}

export default FileMessageComponent



const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px;
    border-radius: 12px;
    width: 100%;
    min-width: 200px;
    max-width: 380px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
`

const IconWrapper = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    
    svg {
        width: 34px;
        height: 34px;
        color: ${({ theme, received }) => received ? "white" : theme.menu?.primaryTextColor || "#333"};
    }
`

const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: 0;
    overflow: hidden;
    
    h1 {
        font-size: 14px;
        font-weight: 600;
        margin: 0 0 2px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${({ theme, received }) => received ? "white" : theme.menu?.primaryTextColor || "#333"};
    }
    
    p {
        font-size: 12px;
        margin: 0;
        color: ${({ theme, received }) => received ? "rgba(255,255,255,0.7)" : theme.menu?.secondaryTextColor || "#666"};
    }
`

const DownloadButton = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: 8px;
    
    background-color: rgba(255,255,255,0.15);
    color: ${({ theme, received }) => received ? theme.chat.receivedMessageTextColor : theme.chat.sentMessageTextColor};
    font-size: 16px;
    border: 1px solid rgba(255,255,255,0.25);
    transition: all 0.2s ease;

    &:hover {
        background-color: rgba(255,255,255,0.3);
        transform: scale(1.05);
    }
`